import { ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { Status, StatusChange, StatusChangeHistory } from "@common/models";
import { AuthenticationService, StatusChangeHistoryService, StatusService } from "@common/services";
import { InsightsService } from "@core/services";
import { environment } from "environments/environment";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ColumnMode } from "@swimlane/ngx-datatable";
import { CustomSwalService } from "app/helpers";
import Swal from "sweetalert2";

@Component({
    selector: "app-ryd-formulas-approval-list",
    templateUrl: "./approval-list.component.html",
    styleUrls: ["./approval-list.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ApprovalListComponent implements OnInit {
  public ColumnMode = ColumnMode;
  public approvalList: StatusChangeHistory[] = [];

  @Input() isModal: boolean;
  @Input() menuId: number;
  @Input() objectId: number | string;
  @Input() statusChange: StatusChange;

  constructor(
    public activeModal: NgbActiveModal,
    private statusChangeHistoryService: StatusChangeHistoryService,
    private _customSwalService: CustomSwalService,
    private _statusService: StatusService,
    private _traslateService: TranslateService,
    private _cdr: ChangeDetectorRef,
    private _insightsService: InsightsService,
    private _authenticationService: AuthenticationService
  ) {}

  /**
   * En el modal se muestra siempre (aunque esté vacía); embebida en el cambio
   * de estado, solo si hay aprobaciones previas y el cambio pide más de una
   */
  get isVisible(): boolean {
    return this.isModal || (this.approvalList.length > 0 && this.statusChange?.approvers > 1);
  }

  /**
   * Nombre de quien aprobó; algunos usuarios no tienen persona asociada
   * @param row Registro del historial
   */
  userName(row: StatusChangeHistory): string {
    const user: any = row?.createdUser;
    if (!user) return '-';
    return user.person ? `${user.person.name} ${user.person.surname}` : `${user.name ?? ''} ${user.surname ?? ''}`.trim();
  }

  ngOnInit(): void {
    this._customSwalService.showLoading();
    this.statusChangeHistoryService
      .getByMenuIdAndObjectId(this.menuId, this.objectId)
      .subscribe(
        (res: StatusChangeHistory[]) => {
          // Se asigna la lista de aprobación
          this.approvalList = res;
          // Se obtiene el estado activo
          const activeStatus = this._statusService.getStatusByCode("ACT");
          // Si se esta recibiendo un cambio de estado se filtra por dicho cambio de estado
          // (no todos los que abren el historial mandan el cambio de estado)
          if (this.statusChange?.newStatus){
            this.approvalList = this.approvalList.filter((sC) => sC.isValid && sC.newStatus.id === this.statusChange.newStatus.id && sC.status.id == activeStatus.id);
          }

          // Se ordena la lista por los últimos
          this.approvalList = this.approvalList.sort((a,b) => b.id - a.id);

          this._customSwalService.close();
          this._cdr.detectChanges();
        },
        (_err) => {
          this.log('Error al cargar el historial de aprobaciones', { menuId: this.menuId ?? null, objectId: this.objectId ?? null }, _err, true);
          this._traslateService.get(['COMMON.APPROVAL_LIST.MESSAGE.ERROR_LOAD'],['COMMON.ACTIONS.OOPS']).subscribe(value => {
            this._customSwalService.showErrorMsg(value['COMMON.APPROVAL_LIST.MESSAGE.ERROR_LOAD'],
            value['COMMON.ACTIONS.OOPS']);
        });
        }
      );
  }

  /**
   * Manda una traza a Application Insights, etiquetada con el proyecto y el
   * usuario que la originó.
   */
  private log(message: string, data: any, ex: any = null, error: boolean = false): void {
    const user = this._authenticationService.currentUserValue;

    if (error) {
      this._insightsService.traceError(environment.projects.StatusChange, message, data, ex, user);
      return;
    }

    this._insightsService.traceInfo(environment.projects.StatusChange, message, data, user);
  }
}
